import Rt from './route';

const gists = [{
  "title": "Home",
  "content": "Your content will go right here",
  "id": 'home',
  "url": '/',
  "description": "Home",
}, {
  "title": "About",
  "content": "Your content will go right here",
  "id": 'about',
  "url": '/about',
  "description": "About Reid",
}, {
  "title": "Sites",
  "content": "Your content will go right here",
  "id": 'sites',
  "url": '/sites',
  "description": "Site Examples",
}, ]



export default gists;

// {
//   "title": "Graphic Design",
//   "content": "Your content will go right here",
//   "id": 'design',
//   "url": '/design',
//   "description": "Design Examples",
// },



// WEBPACK FOOTER //
// ./src/components/gists.js